/* @flow */

export default {
  backSection: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },
  text: {
    display: 'inline-block',
    overflow: 'hidden',

    width: '100%',
    paddingLeft: 4,

    textOverflow: 'ellipsis',
  },
};
